import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useQuickSearchModal } from '../contexts';
import { getProjectLink, isProject } from '../utils';
import { useGetAssetLink } from './useGetAssetLink';

/**
 * Navigates to a Quick Search result page given its id, closing the modal.
 * It can be a project or an asset (file or folder).
 * @param id
 * @returns
 *  href The link to navigate to
 *  callback Callback to fire when ready to navigate
 */
export const useNavigateToResult = (id: string, type: string) => {
  const { toggleModal } = useQuickSearchModal();
  const router = useRouter();
  const assetLink = useGetAssetLink(id);

  const href = isProject(type) ? getProjectLink(id) : assetLink;
  const navigate = useCallback(() => {
    router.push(href);
    toggleModal();
  }, [href, router, toggleModal]);

  return {
    href,
    navigate,
  };
};
